// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const promptInNoteOneMax = 200;

export const promptInSystemTemplateMax = 20000;

export const promptInUserTemplateMax = 20000;

export const PromptIn = zod.object({
  "note": zod.union([zod.string().max(promptInNoteOneMax),zod.null()]).optional(),
  "system_template": zod.string().min(1).max(promptInSystemTemplateMax),
  "user_template": zod.string().min(1).max(promptInUserTemplateMax)
});

export type PromptIn = zod.input<typeof PromptIn>;
export type PromptInOutput = zod.output<typeof PromptIn>;
